export default "__VITE_ASSET__CKcYozPw__"